var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blocked-ip-container" }, [
    _c("div", { staticClass: "blocked-ip-title" }, [
      _vm._v("Erişiminiz Engellendi"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "blocked-ip-description" }, [
      _vm._v(
        "\n        Bu sayfaya erişebilmek için, erişiminize izin veren özel bir ağda olduğunuzdan emin olun; bu durumda bir\n        VPN'e bağlanmanız gerekebilir.\n    "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "blocked-ip-suggestion" }, [
      _vm._v(
        "\n        Alternatif olarak, bir yöneticiden IP adresinizi (" +
          _vm._s(_vm.user.lastLoginIPAddress) +
          ") izin verilenler listesine\n        eklemesini isteyin.\n    "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }